<div class="container my-4">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">Home Connect Push Notification</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row mt-3">
            <div class="col-xl-12">
                <div class="row">
                    <div class="col-xl-12" style="height: fit-content;align-self: end;">
                        <!-- <button class="btn btn-secondary mr-3 " (click)="Reset()">
                                <i class="fa fa-refresh"></i> Refresh
                            </button> -->
                        <app-button (refreshClicked)="Reset()"></app-button>

                        <button class="excel_btn mr-3 mt-2" style="white-space:nowrap;" (click)="exportData()">
                            <i class="fa fa-file-excel"></i> Export
                        </button>
                        <button class="btn btn-primary mr-3" style="white-space:nowrap;"
                            [routerLink]="'/pushNotification'">
                            <i class="fa fa-plus"></i> Add
                        </button>



                    </div>
                </div>

            </div>
            <div class="col-xl-2"></div>
        </div>
        <div class="table-responsive mt-2 mt-4">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                <ng-container matColumnDef="MessagingType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="MessagingType">Messaging Type
                    </mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messagingTypeString}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Recipient">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Recipient">Recipient</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messagingNameString}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messageStatusTypeString }}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Action">Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-eye mr-3"
                                (click)="viewMail(dataField)"></i>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                <p>No data found</p>
            </div>
        </div>

        <div class="table_pagenation">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>